import { createFileRoute, redirect } from '@tanstack/react-router';

// /account is preserved as a redirect for any legacy links / bookmarks. The
// canonical home is now /profile/account under the Profile area.
export const Route = createFileRoute('/_learner/account')({
  beforeLoad: () => {
    throw redirect({ to: '/profile/account' });
  },
});
